import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../shared/api.service';

@Injectable({
  providedIn: 'root'
})
export class ReservationService {

  constructor(private api: ApiService) { }

  //zone 
  public getZones(outlet: number): Observable<any> {
    var rtn = this.api.get(`/api/v1/hq/zone?shop_id=${outlet}`, `reservation`)
    return rtn;
  }

  public getZone(id: number): Observable<any> {
    var rtn = this.api.get(`/api/v1/hq/zone/${id}`, `reservation`)
    return rtn;
  }

  public createZone(data: any): Observable<any> {
    var rtn = this.api.postimageUpload('/api/v1/hq/zone', data, `reservation`)
    return rtn;
  }

  public updateZone(id: number, data: any): Observable<any> {
    var rtn = this.api.postimageUpload(`/api/v1/hq/zone/${id}`, data, `reservation`)
    return rtn;
  }

  public deleteZone(id: number): Observable<any> {
    var rtn = this.api.delete(`/api/v1/hq/zone/${id}`, `reservation`)
    return rtn;
  }

  public changeZoneStatus(id: number, data: any): Observable<any> {
    var rtn = this.api.put(`/api/v1/hq/zone/status/${id}`, data, `reservation`)
    return rtn;
  }

  //table reservation 
  public getTableReservationDetails(outlet: any, q: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/hq/table-reservation?shop_id=${outlet}&q=${q}`, `reservation`)
    return rtn;
  }

  public getTableReservationDetailsForDate(outlet: any, from: any, to: any, q: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/hq/table-reservation?shop_id=${outlet}&from=${from}&to=${to}&q=${q}`, `reservation`)
    return rtn;
  }

  public getTableReservationPagesDetails(outlet: any, pageNumber: any, from: any, to: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/hq/table-reservation?shop_id=${outlet}&page=${pageNumber}&from=${from}&to=${to}`, `reservation`)
    return rtn;
  }

  public updateTableReservation(id: number, data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/hq/table-reservation/${id}`, data, `reservation`)
    return rtn;
  }

  //reservation types
  public getReservationTypes(outlet: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/hq/reservation-type?shop_id=${outlet}`, `reservation`)
    return rtn;
  }

  public getReservationTypesById(id: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/hq/reservation-type/${id}`, `reservation`)
    return rtn;
  }

  public createReservationType(data: any): Observable<any> {
    var rtn = this.api.postimageUpload('/api/v1/hq/reservation-type', data, `reservation`)
    return rtn;
  }

  public updateReservationType(id: number, data: any): Observable<any> {
    var rtn = this.api.postimageUpload(`/api/v1/hq/reservation-type/${id}`, data, `reservation`)
    return rtn;
  }

  public deleteReservationType(id: number): Observable<any> {
    var rtn = this.api.delete(`/api/v1/hq/reservation-type/${id}`, `reservation`)
    return rtn;
  }

  public changeReservationTypeStatus(id: number, data: any): Observable<any> {
    var rtn = this.api.put(`/api/v1/hq/reservation-type/status/${id}`, data, `reservation`)
    return rtn;
  }

  //get settings
  public getGeneralSettings(outlet: string): Observable<any> {
    var rtn = this.api.get(`/api/v1/hq/general-setting/outlet/${outlet}`, `reservation`)
    return rtn;
  }

  public updateGeneralSettings(outlet: string, data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/hq/general-setting/outlet/${outlet}`, data, `reservation`)
    return rtn;
  }

  public snoozeReservation(outlet: string, data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/hq/general-setting/outlet/${outlet}/snooze-reservation`, data, `reservation`)
    return rtn;
  }

  public snoozeAutoConfirmation(outlet: string, data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/hq/general-setting/outlet/${outlet}/snooze-auto-confirmation`, data, `reservation`)
    return rtn;
  }

  public getImages(outlet: string): Observable<any> {
    var rtn = this.api.get(`/api/v1/hq/general-setting/outlet/${outlet}/images?size=medium`, `reservation`)
    return rtn;
  }

  public uploadImages(outlet: string, data: any): Observable<any> {
    var rtn = this.api.postimageUpload(`/api/v1/hq/general-setting/outlet/${outlet}/images`, data, `reservation`)
    return rtn;
  }

  public deleteImage(outlet: string, image: string): Observable<any> {
    var rtn = this.api.delete(`/api/v1/hq/general-setting/outlet/${outlet}/images/${image}`, `reservation`)
    return rtn;
  }

  //unavailable days
  public getUnavailableDays(outlet: string): Observable<any> {
    var rtn = this.api.get(`/api/v1/hq/unavailable-days/outlet/${outlet}`, `reservation`)
    return rtn;
  }

  public createUnavailableDay(data: any): Observable<any> {
    var rtn = this.api.post(`/api/v1/hq/unavailable-days`, data, `reservation`)
    return rtn;
  }

  public deleteUnavailableDay(id: number): Observable<any> {
    var rtn = this.api.delete(`/api/v1/hq/unavailable-days/${id}`, `reservation`)
    return rtn;
  }

  //offers
  public getOffer(offer_id: string): Observable<any> {
    var rtn = this.api.get(`/api/v1/hq/offer/${offer_id}`, `reservation`)
    return rtn;
  }

  public getOffers(outlet: string): Observable<any> {
    var rtn = this.api.get(`/api/v1/hq/offer?shop_id=${outlet}`, `reservation`)
    return rtn;
  }

  public createOffer(data: any): Observable<any> {
    var rtn = this.api.post(`/api/v1/hq/offer`, data, `reservation`)
    return rtn;
  }

  public updateOffer(id: string, data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/hq/offer/${id}`, data, `reservation`)
    return rtn;
  }

  public deleteOffer(id: number): Observable<any> {
    var rtn = this.api.delete(`/api/v1/hq/offer/${id}`, `reservation`)
    return rtn;
  }

  public changeOfferStatus(id: number, data: any): Observable<any> {
    var rtn = this.api.put(`/api/v1/hq/offer/status/${id}`, data, `reservation`)
    return rtn;
  }

  //service availability
  public getServiceAvailability(outlet: string): Observable<any> {
    var rtn = this.api.get(`/api/v1/hq/service-availability/outlet/${outlet}`, `reservation`)
    return rtn;
  }

  public saveServiceAvailability(outlet: string, data: any): Observable<any> {
    var rtn = this.api.post(`/api/v1/hq/service-availability/outlet/${outlet}`, data, `reservation`)
    return rtn;
  }


  // Table creation
  public createSingleTable(data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/hq/table-ordering`, data, `reservation`)
    return rtn;
  }

  public createBulkTable(data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/hq/table-ordering/bulk-store`, data, `reservation`)
    return rtn;
  }

  public modifyAddedTable(id: any, data: any): Observable<any> {
    var rtn = this.api.postfileUpload(`/api/v1/hq/table-ordering/${id}`, data, `reservation`)
    return rtn;
  }

  public deleteAddedTable(id: any): Observable<any> {
    var rtn = this.api.delete(`/api/v1/hq/table-ordering/${id}`, `reservation`)
    return rtn;
  }

  public getAllTables(outlet: any, brand: any): Observable<any> {
    var rtn = this.api.get(`/api/v1/hq/table-ordering?shop_id=${outlet}&brand_id=${brand}`, `reservation`)
    return rtn;
  }
}
